<section class="flex justify-content-center wrapper mb-5 ">
  <div class="wrapper-content lg:gap-2 xl:gap-4 xl:mx-0 sm:mx-3 flex-column xl:flex-row ">
    <main class="content-main f-70 flex flex-column">
      <div class="header-content mb-1">
        <h1 class="title-section title-blue my-2 text-uppercase font-roboto-condensed font-23 font-normal">
          {{ translations.titleMain }}
        </h1>
        <span class="subtitle-section app-text-gray my-2 font-bold" style="margin-inline:4px">
          {{ translations.subtitleMain }}:
        </span>
      </div>
      <div class=" border-outline-blue-light container-content-secondary mb-4">
        <div class="input-text  inline-flex md:border-none w-full">
          <div class="border-circle container-icon ">
            <i class="text-gray-500 pi pi-hashtag"></i>
          </div>
          <input pInputText type="text"  class="input-text-blue w-full" [(ngModel)]="radicado"
                 (keydown.enter)="buscar()" [placeholder]="translations.buscarTramite" />
        </div>
        <div  class="inline-flex ">
          <button pButton class="search bg-blue-light"
                  (click)="buscar()" type="button">
            <span class="title-blue m-0">{{ translations.consultar }}</span>
            <svg-loader name="ico-normal-tramitfly-white" [containerClass]="'blue-dark'"/>
          </button>
        </div>
      </div>
      <div class="app-card h-full ">
        <h2 class="app-card-header color-form-label font-normal font-roboto-condensed font-18">
          {{ translations.titleCardMain }}
          <span class="font-light">{{ detalleTramite?.tramite }}</span>
        </h2>
        <p-divider type="solid" styleClass="my-0"/>

        <div class="grid w-full mx-0">
          @if (detalleTramite || loadingTramite ) {
            <div class="col">
              <span class="app-text-gray font-13">{{ translations.dependencia }}</span>
              <p class=" my-2 brand-blue-light " *ngIf="detalleTramite && !loadingTramite else skeleton ">
                {{ detalleTramite.dependencia | titlecase }}
              </p>

            </div>
            <div class="col">
              <span class="app-text-gray font-13">{{ translations.estadoTramite }}</span>
              <div class="mt-1">
                <p-tag *ngIf="detalleTramite && !loadingTramite else skeleton "
                       [value]="detalleTramite.estado"
                       [severity]="getSeverity(detalleTramite.estado)"></p-tag>
              </div>

            </div>
            <div class="col">
              <span class="app-text-gray font-13">{{ translations.fechaTramite }}</span>
              <p class="app-card-value color-form-label font-weight-regular my-2 font-18"
                 *ngIf="detalleTramite && !loadingTramite else skeleton ">
                {{ detalleTramite.fechaSolicitud | date :'YYYY/MM/dd' }}
              </p>
            </div>
            <div class="col">
              <span class="app-text-gray font-13">{{ translations.horaTramite }}</span>
              <p class="app-card-value mt-2 color-form-label font-weight-regular font-18"
                 *ngIf="detalleTramite && !loadingTramite else skeleton ">
                {{ detalleTramite.fechaSolicitud | date : 'HH:mm:ss' }}
              </p>
            </div>
          } @else {
            <div class="app-card-body  border-round-2xl bg-gray-100 px-4 col md:align-items-center lg:align-items-start flex-column ">
              <h2 class="text-orange-300 mb-0 ">{{translations.noHayRegistros}}</h2>
              <p class="text-gray-500">{{this.translations.noHayRegistrosDetalle}}</p>
             </div>

          }
        </div>
        <div>
          <h4 class="color-form-label font-light font-roboto-condensed font-18 my-0">{{ translations.actividadesDelTramite }}</h4>
        </div>
        <p-divider type="solid" styleClass="my-0"/>

        <div class="app-card-body h-full">
          <p-table [value]="actividades" dataKey="id" [tableStyle]="{'min-width': '50rem'}" [scrollable]="true"
                   [loading]="loadingActividades" scrollHeight="600px" styleClass="p-datatable-sm p-datatable-gridlines"
                   [rows]="size" [rowsPerPageOptions]="[5,10,20]">
            <ng-template pTemplate="header">
              <tr customHeader [columns]="columns"></tr>
            </ng-template>
            <ng-template pTemplate="body" let-tramite let-rowIndex="rowIndex">
              <tr >
                <td class="app-text-gray text-left"> {{ rowIndex + 1 }}</td>
                <td class="app-text-gray text-left">{{ tramite.codificacion }}</td>
                <td class="app-text-gray text-left">{{ tramite.usuarioAsignado }}</td>
                <td>
                  <p-tag [value]="tramite.estadoDescripcion"
                         [icon]="getTramiteEstadoTagIcon(tramite.estadoDescripcion, tramite.usuarioAsignado)"
                         [severity]="getTramiteEstadoTagSeverity(tramite.estadoDescripcion, tramite.usuarioAsignado)"></p-tag>
                </td>
                <td class="text-center app-text-gray text-left">{{ tramite.fechaFinal| date:defaultDateFormat }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ translations.noHayRegistros }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

    </main>
    <div class="content-secondary f-30 lg:flex flex-column mt-4 lg:mt-0 ">
      <div class="header-content mb-1">
        <h1 class="title-section title-blue my-2 text-uppercase font-roboto-condensed font-23 font-normal">
          {{ translations.busquedaTramite }}
        </h1>
        <span class="subtitle-section app-text-gray my-2 font-bold" style="margin-inline:4px">
        </span>
      </div>
      <div>
        <div class=" border-gradient mb-4 flex" style="height:50px;">
          <div class="input-text inline-flex md:border-none w-full">
            <div class="flex align-items-center justify-content-center ml-1 ">
              <img class="icon" alt="icon search" src="assets/img/icons-principal/ico-search.svg">
            </div>
            <input type="text"  class="input-text-gray w-full " pInputText [(ngModel)]="tramite"
                   [placeholder]="translations.tuTramite" (keydown.enter)="searchTramites()" />
          </div>
          <div class="inline-flex gap-1 mr-1 align-items-center">
            <button pButton class="p-button-rounded p-button-icon-only p-button-text">
              <i class="pi pi-ellipsis-v text-blue-general"></i>
            </button>
            <button pButton class="p-button-rounded p-button-icon-only " (click)="searchTramites()">
              <svg-loader name="ico-normal-tramitfly-white"/>
            </button>
          </div>

        </div>
      </div>
      <app-aside-public/>
    </div>
  </div>

</section>
<ng-template #skeleton>
  <p-skeleton width="7rem" />
</ng-template>
